import {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {getNotifications} from '../../../services/notification';
import {DATE_FORMAT} from '../../../consts/common-consts';
import {parseAndFormat} from '../../../helpers/utils/date-util';
import Loader from "../../../components/form-loader/form-loader";
import PageContainer from "../../../components/page-container";
import {Accordion} from 'flowbite-react';
import {HiOutlineBell, HiOutlineArrowTopRightOnSquare} from 'react-icons/hi2';

const mapsStateToProps = (state, ownProps) => {
    return {
        appCreateNotifyMessage: state.appCreateNotifyMessage
    };
}

const mapDispatchToProps = dispatch => {
    return {};
}

function Index({appCreateNotifyMessage}) {
    const [notifications, setNotifications] = useState([]);
    const [formState, setFormState] = useState({
        processing: false,
        success: false,
        failed: false,
        errorMessage: ''
    });

    async function fetchData() {
        updateFormState(true, false, false);
        const {status, response} = await getNotifications();
        if (status === 200) {
            const {data, pagination} = response;
            setNotifications(data);
        }

        updateFormState(false, false, false);
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [appCreateNotifyMessage]);

    const updateFormState = (processing, success, failed, errorMessage) => {
        setFormState(Object.assign({}, {processing, success, failed, errorMessage}))
    }

    return (
        <PageContainer
            title="Notifications"
            subtitle="Updates and alerts from your workspace"
        >
            <div className="pb-8">

                {formState.processing && <div className="py-6"><Loader/></div>}

                {(!formState.processing && notifications.length === 0) &&
                    <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-gray-200 bg-gray-50/60 py-16">
                        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gray-100">
                            <HiOutlineBell className="h-7 w-7 text-gray-400"/>
                        </div>
                        <p className="text-lg font-semibold tracking-tight text-gray-900">
                            No notifications
                        </p>
                        <p className="text-sm text-gray-500">
                            You're all caught up.
                        </p>
                    </div>
                }

                {(!formState.processing && notifications.length > 0) &&
                    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                        <Accordion flush>
                            {notifications.map(
                                (notification, index) =>
                                    <Accordion.Panel key={index}>
                                        <Accordion.Title className="px-5 py-4 hover:bg-gray-50/70 focus:ring-0">
                                            <div className="flex items-start gap-3 text-left">
                                                <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray-100">
                                                    <HiOutlineBell className="h-4 w-4 text-gray-500"/>
                                                </div>
                                                <div className="min-w-0">
                                                    <div className="text-sm font-medium text-gray-900">
                                                        {notification.message}
                                                    </div>
                                                    <div className="mt-0.5 text-xs text-gray-400">
                                                        {parseAndFormat(notification.createdAt, DATE_FORMAT)}
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Title>
                                        <Accordion.Content className="border-t border-gray-100 bg-gray-50/50 px-5 py-4">
                                            <dl className="flex flex-col gap-2.5">
                                                {Object.keys(notification.metadata || {}).map((metadataKey, mi) => {
                                                    const element = notification.metadata[metadataKey];
                                                    return (
                                                        <div key={mi} className="flex flex-wrap items-baseline gap-2">
                                                            <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
                                                                {element.title}
                                                            </dt>
                                                            <dd className="text-sm text-gray-700">
                                                                {(element.type === 'url') ?
                                                                    <a
                                                                        href={element.value}
                                                                        target="_blank"
                                                                        rel="noreferrer"
                                                                        className="inline-flex items-center gap-1 font-medium text-primary underline-offset-2 transition-colors hover:underline"
                                                                    >
                                                                        Open link
                                                                        <HiOutlineArrowTopRightOnSquare className="h-3.5 w-3.5"/>
                                                                    </a>
                                                                    : element.value
                                                                }
                                                            </dd>
                                                        </div>
                                                    )
                                                })}
                                            </dl>
                                        </Accordion.Content>
                                    </Accordion.Panel>
                                )}
                        </Accordion>
                    </div>
                }
            </div>
        </PageContainer>
    )
}

export default connect(mapsStateToProps, mapDispatchToProps)(Index)